import React from "react";
import img1 from "../../assets/image/features/1.png";
import img2 from "../../assets/image/features/2.png";
import img3 from "../../assets/image/features/3.png";
import img4 from "../../assets/image/features/4.png";
import img5 from "../../assets/image/features/5.png";
import img6 from "../../assets/image/features/6.png";
import img7 from "../../assets/image/features/7.png";
import img8 from "../../assets/image/features/8.png";
import img9 from "../../assets/image/features/9.png";
import img10 from "../../assets/image/features/10.png";
import img11 from "../../assets/image/features/11.png";

const features = [
  {
    title: "Web & Mobile Login",
    description:
      "Seamless access across web and mobile platforms for efficient management anytime, anywhere.",
    image: img1,
  },
  {
    title: "Ticket Management",
    description:
      "Streamline issue tracking and resolution with an intuitive ticketing system, ensuring efficient support handling.",
    image: img2,
  },
  {
    title: "Custom FSR Reports",
    description:
      "Generate fully customizable Field Service Reports for better data analysis and decision-making.",
    image: img3,
  },
  {
    title: "User-wise Dashboard",
    description:
      "Personalized dashboards for each user, providing real-time insights and key performance metrics.",
    image: img4,
  },
  {
    title: "Attendance & Leave Management",
    description:
      "Simplified employee attendance and leave tracking to maintain workflow efficiency.",
    image: img5,
  },
  {
    title: "User Access & Limitations",
    description:
      "Define and manage user roles with access restrictions to ensure secure operations.",
    image: img6,
  },
  {
    title: "Field Expenses",
    description:
      "Track and control field expenses with detailed reports and real-time monitoring.",
    image: img7,
  },
  {
    title: "Material Request",
    description:
      "Easily request and manage materials, ensuring timely availability and inventory control.",
    image: img8,
  },
  {
    title: "CRM for Sales Team",
    description:
      "Empower sales teams with a built-in CRM to track leads, conversions, and customer interactions.",
    image: img9,
  },
  {
    title: "Employee Tracking",
    description:
      "Monitor employee locations and movements in real-time to optimize field operations.",
    image: img10,
  },
  {
    title: "AMC Management",
    description:
      "Effortlessly manage Annual Maintenance Contracts, renewals, and service schedules.",
    image: img11,
  },
];

const Features = () => {
  return (
    <section className="py-5 bg-light">
      <div className="container">
        <h2 className="display-5 fw-bold text-center text-dark mb-3">
          Key Features of Fieldsathi TMS
        </h2>
        <p className="text-center text-muted lead mb-5">
          Fieldsathi TMS is a comprehensive solution designed to enhance
          workforce efficiency and streamline field operations. With a variety
          of features tailored to simplify management, tracking, and reporting,
          our platform ensures seamless integration across teams, leading to
          improved productivity and data-driven decision-making.
        </p>
        <div className="row g-4 pb-5">
          {features.map((feature, index) => (
            <div key={index} className="col-md-6 col-lg-4 pb-5">
              <div className="card border-0 shadow-sm h-100">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="card-img-top rounded"
                  style={{ height: "200px", objectFit: "cover" }}
                />
                <div className="card-body">
                  <h3 className="h5 fw-semibold text-dark">{feature.title}</h3>
                  <p className="text-muted">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
